import { render, staticRenderFns } from "./TermAndConditions.vue?vue&type=template&id=789bbd82&scoped=true"
import script from "./TermAndConditions.vue?vue&type=script&lang=js"
export * from "./TermAndConditions.vue?vue&type=script&lang=js"
import style0 from "./TermAndConditions.vue?vue&type=style&index=0&id=789bbd82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789bbd82",
  null
  
)

export default component.exports